import { render } from "./SingleChoiceRenderer.vue?vue&type=template&id=39727d68&scoped=true"
import script from "./SingleChoiceRenderer.vue?vue&type=script&lang=js"
export * from "./SingleChoiceRenderer.vue?vue&type=script&lang=js"

import "./SingleChoiceRenderer.vue?vue&type=style&index=0&id=39727d68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39727d68"]])

export default __exports__